module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {}
  }, [_c('div', {
    attrs: {
      "id": "main-card-front"
    }
  }, [_c('div', {
    attrs: {
      "slot": "front"
    },
    slot: "front"
  }, [_c('div', {
    staticClass: "card main-card shadow"
  }, [_c('img', {
    staticStyle: {
      "max-height": "230px",
      "width": "100%"
    },
    attrs: {
      "src": require('@/assets/images/logo.png')
    },
    on: {
      "click": function($event) {
        return _vm.showModalWords()
      }
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dafab3e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/concept-card.vue
// module id = oZpD
// module chunks = 1